import * as React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FMIconButton, FMTextInput } from 'atoms';
import style from './SearchInput.style';

interface Props {
    filter: (text: string) => void;
    classes: any;
    placeholder: string;
}

interface State {
    text: string;
}

class FilterInput extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            text: '',
        };
    }

    private updateText = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ text: event.target.value });
        this.props.filter(event.target.value);
    }

    public render() {
        const { classes } = this.props;

        return (
            <div className={classes.searchContainer}>
                <FMTextInput
                    className={classes.searchInput}
                    type="text"
                    placeholder={this.props.placeholder}
                    value={this.state.text}
                    onChange={this.updateText}
                />
                <FMIconButton
                    color="secondary"
                    className={classes.searchButton}
                    type="filter"
                />
            </div>
        );
    }

}

export default withStyles(style)(FilterInput);
